import React, { useEffect, useState } from "react";
import baseUrl from "../../../../api/baseUrl";
import SecurityIcon from "@mui/icons-material/Security";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

function DeactiveRole() {
  const [tableData, settableData] = useState([]);
  useEffect(() => {
    baseUrl
      .get("/role/findRole", { headers: { status: "false" } })
      .then((response) => settableData(response.data.data))
      .catch((error) => console.log(error));
  }, []);

  return (
    <div className="space-y-3">
      {/* Header */}
      <div className="bg-white dark:bg-slate-800 rounded-[8px] shadow-lg shadow-slate-200/50 dark:shadow-slate-900/50 border border-slate-100 dark:border-slate-700 p-3">
        <div className="flex items-center gap-2.5">
          <div className="w-8 h-8 bg-amber-100 rounded-lg flex items-center justify-center">
            <SecurityIcon className="text-amber-600" sx={{ fontSize: 16 }} />
          </div>
          <div>
            <h2 className="text-sm font-bold text-slate-800 dark:text-slate-100">Inactive Roles</h2>
            <p className="text-xs text-slate-500 dark:text-slate-400">{tableData.length} deactivated roles</p>
          </div>
        </div>
      </div>

      {/* Mobile Cards */}
      <div className="md:hidden space-y-2">
        {tableData.map((item: any, i: number) => (
          <div key={i} className="bg-white dark:bg-slate-800 rounded-lg shadow-sm border border-amber-100 dark:border-amber-900/40 p-3">
            <div className="flex items-center justify-between mb-2">
              <span className="text-[10px] font-medium text-slate-400 dark:text-slate-500">#{i + 1}</span>
              <span className="px-1.5 py-0.5 bg-amber-100 dark:bg-amber-900/40 text-amber-600 dark:text-amber-300 text-[10px] font-medium rounded-md">Inactive</span>
            </div>
            <h3 className="font-semibold text-xs text-slate-800 dark:text-slate-100 mb-2">{item?.roleName}</h3>
            <button className="w-full flex items-center justify-center gap-1 px-3 py-2 bg-gradient-to-r from-primary to-primaryLight text-white rounded-lg text-xs font-medium hover:shadow-lg hover:shadow-primary/20 transition-all">
              <CheckCircleIcon sx={{ fontSize: 14 }} /> Activate
            </button>
          </div>
        ))}
      </div>

      {/* Desktop Table */}
      <div className="hidden md:block bg-white dark:bg-slate-800 rounded-[8px] shadow-lg shadow-slate-200/50 dark:shadow-slate-900/50 border border-slate-100 dark:border-slate-700 overflow-hidden">
        <table className="w-full">
          <thead className="border-b border-slate-200 dark:border-slate-600">
            <tr>
              <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 dark:text-slate-300 uppercase tracking-wider">No</th>
              <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 dark:text-slate-300 uppercase tracking-wider">Role Name</th>
              <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 dark:text-slate-300 uppercase tracking-wider">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100 dark:divide-slate-600">
            {tableData.map((item: any, i: number) => (
              <tr key={i} className="hover:bg-slate-50 transition-colors">
                <td className="px-3 py-2 text-xs text-slate-500 dark:text-slate-400">{i + 1}</td>
                <td className="px-3 py-2 font-medium text-xs text-slate-800 dark:text-slate-100">{item?.roleName}</td>
                <td className="px-3 py-2">
                  <button className="flex items-center gap-1 px-3 py-1.5 bg-gradient-to-r from-primary to-primaryLight text-white rounded-lg text-xs font-medium hover:shadow-lg hover:shadow-primary/20 transition-all">
                    <CheckCircleIcon sx={{ fontSize: 14 }} /> Activate
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default DeactiveRole;
